<template>
  <div class="box">
    <div class="header">
      <div class="title">{{ title }}</div>
      <a class="btn btn-mod more-btn" @click="handleMoreDetailsClick">
        <span>Detaljnije</span>
      </a>
    </div>
    <div class="table">
      <div class="labels row">
        <div
          class="column"
          v-for="column in columns"
          :key="column.key"
          :style="{ flex: column.flex }"
        >
          {{ column.label }}
        </div>
      </div>
      <div v-if="!isLoading">
        <div class="row" v-for="row in tableData" :key="row.id">
          <div
            class="column column-data"
            v-for="column in columns"
            :key="column.key"
            :style="{ flex: column.flex }"
            :class="{
              'color-transaction-expense':
                column.key === 'amount' && row[column.key] < 0,
              'color-transaction-income':
                column.key === 'amount' && row[column.key] >= 0
            }"
          >
            <div v-if="shouldAddSeparator(column.key)">
              {{ row[column.key] | addSeparator }}
            </div>
            <div v-else>{{ row[column.key] }}</div>
          </div>
        </div>
      </div>
      <div
        v-if="!tableDetails.isLoading && tableDetails.count === 0"
        class="message-wrapper"
      >
        Nema podataka
      </div>
      <div
        v-if="tableDetails.isLoading"
        class="message-wrapper loading-wrapper"
      >
        Učitavanje podataka
        <span>.</span>
        <span>.</span>
        <span>.</span>
      </div>
      <div class="more-dots">
        <h3 v-if="tableDetails.count > 5">...</h3>
      </div>
    </div>
    <div class="footer">
      <a
        class="btn"
        v-for="action in actions"
        :key="action.key"
        :class="action.class"
        @click="handleShowModal(action.modalName)"
      >
        <span>{{ action.label }}</span>
        <i class="fas fa-plus"></i>
      </a>
    </div>
  </div>
</template>
<script>
import { financesInstance } from '@/axios/axios.js';
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import { addSeparatorMixin } from '@/mixins/mixins.js';

export default {
  props: {
    title: { type: String, required: true },
    columns: { type: Array, required: true },
    name: { type: String, required: true },
    actions: { type: Array, required: true },
    modalWider: { type: Boolean, default: false }
  },
  computed: {
    ...mapState('finances', ['isLoading']),
    tableDetails() {
      return this.$store.getters['finances/getTableDetails'](this.name);
    },
    tableData() {
      return this.$store.getters['finances/getLastFiveRowsForTable'](this.name);
    }
  },
  mixins: [addSeparatorMixin],
  methods: {
    ...mapMutations('modal', ['showModal', 'showModalWider']),
    ...mapActions('finances', ['getTableData']),
    shouldAddSeparator(columnName) {
      switch (columnName) {
        case 'amount':
          return true;
        case 'price':
          return true;
        case 'total_amount':
          return true;
        case 'total':
          return true;
        default:
          return false;
      }
    },
    handleMoreDetailsClick() {
      const nameCapitalized =
        this.name.charAt(0).toUpperCase() + this.name.slice(1);
      this.$router.push({
        name: 'community' + nameCapitalized
      });
    },
    handleShowModal(modalName) {
      if (this.modalWider || modalName == 'ModalContentTransactionIncome') {
        this.showModalWider(modalName);
      } else {
        this.showModal(modalName);
      }
    },
    getAmountStyling(a, b) {}
  },
  created() {
    this.getTableData({
      communityId: this.$store.getters.getActiveCommunity.id,
      tableName: this.name
    });
  }
};
</script>
<style scoped lang="scss">
.column-data {
  white-space: nowrap;
  overflow: hidden;
  div {
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 8px;
  }
}

.btn {
  padding: 6px;
  font-size: 0.9rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span,
  i {
    color: #fff;
  }
  i {
    margin-left: 8px;
  }
  &.btn-mod {
    background: rgba(85, 85, 85, 1);
    &:hover {
      background: rgba(75, 75, 75, 1);
    }
  }
  &.btn-danger {
    background: rgba(220, 53, 70, 1);
    &:hover {
      background: rgba(200, 53, 70, 1);
    }
  }
}
.box {
  width: 100%;
  height: 100%;
  // border: 1px solid var(--primary-color);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

  border-radius: 4px;
  .header {
    display: flex;
    justify-content: space-between;
    height: 20%;
    padding: 8px;
    .title {
      font-weight: 600;
      font-size: 1.3rem;
      border-bottom: 1px solid gray;
    }
    .more-btn {
      padding: 6px;
      font-size: 0.9rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .table {
    height: 60%;
    margin-bottom: 0;
    font-size: 0.9rem;
    padding: 0 8px;
    position: relative;
    .row {
      height: 15%;
      width: 100%;
      display: flex;
      .column {
        text-align: left;
        flex: 1;
        display: flex;
        align-items: center;
      }
    }
    .labels {
      border-bottom: 1px solid gray;
      .column {
        font-weight: 600;
      }
    }
    .more-dots {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 10%;
      width: 100%;
      h3 {
        font-size: 3rem;
        margin-top: -36px;
        text-align: center;
      }
    }
  }

  .footer {
    height: 20%;
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    padding: 8px;
    align-items: center;
    a {
      height: 100%;
    }
    .btn {
      margin: 0 8px;
    }
  }
}

.color-transaction-expense {
  color: #cc0000;
}
.color-transaction-income {
  color: #00ab16;
}
.message-wrapper {
  margin-top: 0.2rem;
  &.loading-wrapper {
    span {
      font-size: 2rem;
      line-height: 1rem;
      animation-name: blink;
      animation-duration: 1.4s;
      animation-iteration-count: infinite;
      animation-fill-mode: both;
    }

    span:nth-child(2) {
      animation-delay: 0.2s;
    }

    span:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
}
@keyframes blink {
  /**
     * At the start of the animation the dot
     * has an opacity of .2
     */
  0% {
    opacity: 0.2;
  }
  /**
     * At 20% the dot is fully visible and
     * then fades out slowly
     */
  20% {
    opacity: 1;
  }
  /**
     * Until it reaches an opacity of .2 and
     * the animation can start again
     */
  100% {
    opacity: 0.2;
  }
}
</style>